export const DEFAULT_OUTLOOK_THEME_COLOR = '#0078D4';
export const DEFAULT_TEAMS_PURPLE_THEME_COLOR = '#5B5FC7';
export const BASE_THEME_ID = 'base';
export const BASE_DARK_THEME_ID: 'base.dark' = `${BASE_THEME_ID}.dark`;
export const LEGACY_PRELOADED_THEME_IDS: string[] = [BASE_THEME_ID, BASE_DARK_THEME_ID];
